import React from 'react'

import { Skeleton } from 'components/Skeleton'

import { Color } from 'root-constants'

import { StyledCarouselSkeleton as S } from './CarouselSkeleton.styles'

type TProps = {
  height: number
  dotsCount: number
}

export const CarouselSkeleton: React.FC<TProps> = ({ height, dotsCount }) => (
  <S.Wrapper>
    <Skeleton
      isLoading
      height={height}
      radius={24}
      background={Color.GRAY_LIGHTEST}
    />

    <S.Dots>
      {Array.from({ length: dotsCount }, (_, index) => (
        <S.Dot key={index} />
      ))}
    </S.Dots>
  </S.Wrapper>
)
